<template>
  <div class="theme-provider">
    <slot />
  </div>
</template>

<script setup lang="ts">
  const { brandCode } = defineProps<{
    brandCode: string;
  }>();

  await useHeadAssets(brandCode);

  const styleCode = getStyleNamespace(brandCode, true);

  const cssFiles = import.meta.glob<string>('../../node_modules/@tapp/design-tokens/vars/*.css', {
    query: '?inline',
    import: 'default',
  });

  const cssFontFiles = import.meta.glob<string>(
    '../../node_modules/@tapp/layer-design-system/assets/styles/fonts/*.css',
    {
      query: '?inline',
      import: 'default',
    },
  );

  const cssFilePath = `../../node_modules/@tapp/design-tokens/vars/${styleCode}.css`;
  const cssFontFilePath = `../../node_modules/@tapp/layer-design-system/assets/styles/fonts/${styleCode}_fonts.css`;

  try {
    const loadCss = cssFiles[cssFilePath];
    const loadFontsCss = cssFontFiles[cssFontFilePath];
    if (!loadCss || !loadFontsCss) throw new Error(`No CSS files found for style code ${styleCode}`);

    const cssContent = await loadCss();
    const cssFontsContent = await loadFontsCss();

    useHead({
      style: [
        { innerHTML: cssContent, id: 'app_brand_style_namespace' },
        { innerHTML: cssFontsContent, id: 'app_brand_fonts_namespace' },
      ],
    });
  } catch (error) {
    console.error(`Error loading CSS files for brand code ${brandCode}:`, error);
  }
</script>
